<section class='all-locations'>
  <div class="location-details">
    @if (isDataLoaded) {
      <div class='available-locations-details' [ngClass]='this.tableData?.customClass'>
        <div [ngClass]="showNodata ? 'no-data-height' : ''">
          <!-- Table Starts here-->
          <div id={{tableData.tableId}} [ngClass]="showNodata ? 'no-data-height' : ''">

            <cdk-virtual-scroll-viewport #scroll [itemSize]="100" minBufferPx="1500" maxBufferPx="2000"
              class='table-body' id="app-tale-body-{{tableData.tableId}}" [ngClass]="{'no-data': showNodata}">

              <div
                *cdkVirtualFor="let data of tableData?.tableData let Index = index; trackBy: trackFunction">
                <div #apptablerow id="app-tale-row" class='table-row'>

                  <!-- Body data -->
                  @for (header of tableColumn; track header; let i = $index) {
                    @if(data[header] === 'itemName' || header === 'itemName') {
                      <div class='data-{{header}}'>{{data[header]}}</div>
                    }
                    @if(data[header] !== 'itemName' && header !== 'itemName') {
                      <div class='body-col data-{{header}}' id='{{tableData.orderId[i]}}'>
                        <div class='body-data'>
                          @if(header !== 'itemName') {
                            <div class='body-header'>
                              {{tableData.tableHeader[i] | translate}}
                            </div>
                          }
                          <div class='body-content'>
                            @if (data[header] !== 'itemName') {
                              <span class='text'
                              [innerHTML]="data[header] | isEmpty | highlight: highlightText"></span>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>

              <!-- No Items Component -->
              @if (showNodata) {
                <app-no-items [addNewClass]="(showNodata) ? 'noDataFullScreen' : ''"></app-no-items>
              }

            </cdk-virtual-scroll-viewport>

          </div>
        </div>
      </div>
    }
  </div>
</section>